<template>
  <div>
    <v-row>
      <v-col>
        <v-icon class="pr-2">mdi-school</v-icon>
        <p class="subtitle-1" style="display: inline-block;">{{ diploma.diplomaName }} a</p>
        <span class="subtitle-2 institute font-weight-bold ml-1">{{diploma.institute }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              class="ml-1"
              v-on="on"
              color="green"
              v-if="diploma.status=='accepted'"
            >mdi-checkbox-marked-circle</v-icon>
          </template>
          Vérifier
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["diploma"]
};
</script>

<style scoped>
span {
  color: rgb(11, 6, 59);
}

.institute {
  color: black;
}
</style>
